import { render, staticRenderFns } from "./iRtfField.vue?vue&type=template&id=645077c4&"
import script from "./iRtfField.vue?vue&type=script&lang=js&"
export * from "./iRtfField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports